import React from 'react';
import M3Dialog, { DialogTitle, DialogBody } from './M3Dialog';
import ResourceForm from './ResourceForm';
import M3LinearProgress from './M3Progress';

/**
 * M3 dialog hosting a ResourceForm — create/edit flows that stay on the
 * current page instead of navigating to a form route.
 *
 * The form is only mounted once `resource` has resolved (or immediately
 * for creates), and M3Dialog unmounts it on close, so field state always
 * re-initializes from the record on open.
 *
 * @param {boolean} open
 * @param {string} title — dialog heading, e.g. 'New Site' / 'Edit Site'
 * @param {object|null} resource — loaded record (null while creating)
 * @param {Array} fields — ResourceForm field descriptors
 * @param {boolean} resourceLoading — record query still resolving
 * @param {boolean} [loading] — submit in flight (disables Save)
 * @param {string} [submitLabel]
 * @param {Function} onSubmit — async (formState) => Promise
 * @param {Function} onClose
 */
export default function ResourceFormDialog({
  open,
  title,
  resource,
  fields,
  resourceLoading,
  loading,
  submitLabel,
  onSubmit,
  onClose
}) {
  if (!open) return null;

  return (
    <M3Dialog open={open} size="medium" onClose={onClose} title={title}>
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        {resourceLoading ? (
          <M3LinearProgress indeterminate />
        ) : (
          <ResourceForm
            key={resource?.id ?? 'new'}
            resource={resource ?? null}
            fields={fields}
            onSubmit={onSubmit}
            onCancel={onClose}
            loading={loading}
            submitLabel={submitLabel}
            hideHeading
          />
        )}
      </DialogBody>
    </M3Dialog>
  );
}
